// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-catalog-CatalogsTree-CatalogsTree-module__frame--K_pmF {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-business-catalog-CatalogsTree-CatalogsTree-module__classifiers--ae9rX {
  padding: 0 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-business-catalog-CatalogsTree-CatalogsTree-module__clsTitle--vj9uU {
  color: rgba(0, 0, 0, 0.55);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-business-catalog-CatalogsTree-CatalogsTree-module__tree--zWGA9 {
  flex: 1;
  overflow: auto;
  padding: 8px 16px 0;
}
/*# sourceMappingURL=CatalogsTree.module.css.map */`, "",{"version":3,"sources":["webpack://./CatalogsTree.module.less","webpack://./src/business/catalog/CatalogsTree/CatalogsTree.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;ACAF;ADGA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACDF;ADIA;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;ADKA;EACE,OAAA;EACA,cAAA;EACA,mBAAA;ACHF;AACA,kDAAkD","sourcesContent":[".frame {\n  height: 100%;\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.classifiers {\n  padding: 0 16px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.clsTitle {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n\n.tree {\n  flex: 1;\n  overflow: auto;\n  padding: 8px 16px 0;\n}\n",".frame {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.classifiers {\n  padding: 0 16px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.clsTitle {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n.tree {\n  flex: 1;\n  overflow: auto;\n  padding: 8px 16px 0;\n}\n/*# sourceMappingURL=CatalogsTree.module.css.map */"],"sourceRoot":""}]);
// Exports
export var frame = `src-business-catalog-CatalogsTree-CatalogsTree-module__frame--K_pmF`;
export var classifiers = `src-business-catalog-CatalogsTree-CatalogsTree-module__classifiers--ae9rX`;
export var clsTitle = `src-business-catalog-CatalogsTree-CatalogsTree-module__clsTitle--vj9uU`;
export var tree = `src-business-catalog-CatalogsTree-CatalogsTree-module__tree--zWGA9`;
export default ___CSS_LOADER_EXPORT___;
